function toTitleCase(str) {
  return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1);});
}

//This model will titlecase all it's attributes
// extend this model if you ever need to force attributes
// to be uppercase
const TitleCaseModel = Backbone.Model.extend({

  constructor: function (attributes, options) {

    var attrs = {};
    _.each(attributes, function(value, key) {
      var key = toTitleCase(key);
      attrs[key] = value;
    });

    Backbone.Model.apply(this, [attrs, options]);
  }

});

export default TitleCaseModel;
